<template lang="pug">
.sdo-chat-input
  strong.success--text.text--lighten-1.ml-4(
    v-if="chat.alertOptions.saveAnswer"
  ) Внимание, ваш текущий ответ будет сохранен в базу знаний нейросети как ответ на вопрос
  v-textarea(
    ref="chatInput"
    v-model="text"
    filled
    rounded
    auto-grow
    outlined
    rows="0"
    :placeholder="loading ? 'Отправка сообщения...' : 'Наберите сообщение'"
    append-icon="mdi-send"
    single-line
    autofocus
    hide-details
    :disabled="loading"
    @keydown.enter.exact.prevent="sendMessage"
    @keydown.enter.shift.exact.prevent="text += '\\n'"
    @click:append="sendMessage"
  )
</template>

<script>
export default {
  inject: ['chat'],
  props: {
    knowledgeBaseId: { type: Number, default: null },
  },
  data() {
    return {
      text: null,
      loading: false,
    };
  },
  computed: {
    canSendMessage() {
      return !!this.text;
    },
  },
  watch: {
    'chat.alertOptions': {
      handler(val) {
        if (val.copyTextAnswer) {
          this.text = this.chat.alertOptions.message.gpt_request.response.answer;
        }
      },
      deep: true,
    },
  },
  methods: {
    focusInput() {
      const { chatInput } = this.$refs;
      setTimeout(() => chatInput.$refs.input.focus(), 4);
    },
    async sendMessage() {
      const bufferText = this.text;
      if (this.canSendMessage) {
        this.loading = true;
        this.text = null;
        if (this.chat.alertOptions.saveAnswer) {
          const params = {
            is_writer: true,
            type: 1,
            knowledge_base_id: this.knowledgeBaseId,
            question: { text: this.chat.alertOptions.message.text },
            answer: { text: bufferText },
          };
          this.$api.gptPulse.createQuestion(params);
        }
        this.$emit('unselect');
        await this.chat.sendMessage({ text: bufferText });
        this.loading = false;
        this.focusInput();
      }
    },
  },
};
</script>
